import { all, call, put, takeEvery } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actions from "./actions";

function* sendMailingCampaign(action) {
  try {
    const result = yield call(AxiosPost, `/brevo/set_recurring_email_campaing/`, action.payload);
    if (result.status !== 200)
      throw new Error('error al sincronizar la base de datos');

    yield put(actions.sendMailingCampaignSuccess());
  } catch (e) {
    yield put(actions.sendMailingCampaignFailure(e));
  }
}

function* syncBrevoDatabase() {
  try {
    const result = yield call(AxiosCall, '/brevo/sync_db/');

    if (result.status !== 200)
      throw new Error('error al sincronizar la base de datos');

    yield put(actions.syncBrevoSuccess());
  } catch (e) {
    yield put(actions.syncBrevoFailure(e));
  }
}

export default function* brevoUtilitySaga() {
  yield all([
    // watchers
    takeEvery(actions.SEND_MAILING_CAMPAIGN.REQUEST, sendMailingCampaign),
    takeEvery(actions.SYNC_BREVO.REQUEST, syncBrevoDatabase),
  ])
}